export * from "./customer-testimonials";
export { ADG4CustomerTestimonials as default } from "./customer-testimonials";
